module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitlel"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tables")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#tab1"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Table 1")]), _vm._v(" The military career of Lucius Artorius Castus")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#tab2"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Table 2")]), _vm._v(" Debatable terms and options")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#tab3"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Table 3")]), _vm._v(" Roman Emperors and relevant campaigns")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#tab4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Table 4")]), _vm._v(" The French Romances")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#tab5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Table 5")]), _vm._v(" The Welsh tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03#tab6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Table 6")]), _vm._v(" Equestrian grades of the early second century")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03a#tab7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Table 7")]), _vm._v(" Timeline of Roman Britain")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03a#tab8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Table 8")]), _vm._v(" Examples of known procurators under Marcus Aurelius")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03a#tab9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Table 9")]), _vm._v(" The Artorius-Arthur theory assessed")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#tab10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Table 10")]), _vm._v(" Auxiliary units of Britannia")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#tab11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Table 11")]), _vm._v(" Analysis of Sarmation connection")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05#tab12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Table 12")]), _vm._v(" The options dating Artorius Castus")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05#tab13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Table 13")]), _vm._v(" Timelines for the Armenian campaigns")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05#tab14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Table 14")]), _vm._v(" Timelines for armatos")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter07#tab15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Table 15")]), _vm._v(" Genealogies of Welsh kings and saints")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter07#tab16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Table 16")]), _vm._v(" The battle list")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter07#tab17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Table 17")]), _vm._v(" The contenders for the identity of Arthur")])]), _vm._v(" "), _c('h2', {
    staticClass: "fmtitlel"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Maps and Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#fig1"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 1")]), _vm._v(" Map of location of inscriptions")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#fig2"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 2")]), _vm._v(" Picture of funerary inscription stone of Lucius Artorius Castus")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#fig3"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 3")]), _vm._v(" Map showing the career of Lucius Artorius Castus")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#fig4"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 4")]), _vm._v(" Legion command structure")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#fig5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 5")]), _vm._v(" Map of Arthurian landmarks")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#fig6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 6")]), _vm._v(" Map of Arthurian sites")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#fig7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 7")]), _vm._v(" Map showing major concentration of Roman villas and extent of earliest Germanic material culture and settlement")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03#fig8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 8")]), _vm._v(" Republic governmental structure")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03#fig9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 9")]), _vm._v(" Imperial governmental structure")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 10")]), _vm._v(" Map of Imperial and Senatorial provinces "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 117")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03#fig11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 11")]), _vm._v(" Map of Roman-Parthian Campaign "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 161–6")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 12")]), _vm._v(" Career paths of senators and equestrians")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03a#fig13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 13")]), _vm._v(" Map of Roman Britain in the second century")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03a#fig14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 14")]), _vm._v(" Map of Roman Britain military organisation in the north c. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 180")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03a#fig15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 15")]), _vm._v(" Map of Roman forts on the Antonine Wall")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03a#fig16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 16")]), _vm._v(" Civil and military administrative structure of Britannia in the second century")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03a#fig17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 17")]), _vm._v(" Map of Roman Provinces of Britannia from c. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 212")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03a#fig18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 18")]), _vm._v(" Map of Roman Britain northern campaigns "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 208–211")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03a#fig19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 19")]), _vm._v(" Career paths in the Empire: Centurion to procurator")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#fig20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 20")]), _vm._v(" Map of origins of the Scythians")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#fig21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 21")]), _vm._v(" Scythian gold artefact c. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BC")]), _vm._v(" 400")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#fig22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 22")]), _vm._v(" Sarmatians, Roxolani and Alani second-century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#fig23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 23")]), _vm._v(" Artist’s representation of Sarmatians, Dacians and Scythians")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#fig24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 24")]), _vm._v(" Stone relief showing Roman and Sarmatian cavalry")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#fig25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 25")]), _vm._v(" Stone relief of possible Dacian or Sarmatian cavalryman")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#fig26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 26")]), _vm._v(" Stone relief of Dacian Draco standard with armoured tunic")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#fig27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 27")]), _vm._v(" Map of locations showing potential Sarmatian presence")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#fig28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 28")]), _vm._v(" Timeline of an urban myth")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05#fig29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 29")]), _vm._v(" Map showing location of Legions III Gallica and VI Ferrata")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05#fig30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 30")]), _vm._v(" Map showing location of Legions II Adiutrix and V Macedonia")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05#fig31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 31")]), _vm._v(" Map showing location of Misenum fleet")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05#fig32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 32")]), _vm._v(" Map showing location of Praefectus legionis legio VI Victrix")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05#fig33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 33")]), _vm._v(" Map of Roman camp layout")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05#fig34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 34")]), _vm._v(" Map of Chesters Roman fort")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05#fig35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 35")]), _vm._v(" Map of journey Britannia to Armenia")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05#fig36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 36")]), _vm._v(" Relief map of Armenia")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05#fig37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 37")]), _vm._v(" Roman centurion and option c. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 200")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter06#fig38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 38")]), _vm._v(" Map of Roman Britain c. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 400")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter06#fig39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 39")]), _vm._v(" Map of Provinces of Roman Britain c. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 400")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter06#fig40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 40")]), _vm._v(" Map showing pre-mid-fifth-century evidence of Germanic culture")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter06#fig41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 41")]), _vm._v(" map showing Germanic material culture and settlement mid-fifth century")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter06#fig42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 42")]), _vm._v(" Map of early battle sites of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anglo-Saxon Chronicles")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter06#fig43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 43")]), _vm._v(" Map showing extent of Germanic culture and burials c. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 500")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter06#fig44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 44")]), _vm._v(" Map of post-provincial Britain")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter07#fig45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 45")]), _vm._v(" Welsh genealogies connecting "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Saints’ Lives")]), _vm._v(" with Arthur")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter07#fig46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 46")]), _vm._v(" The Northern Genealogies and Arthur")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter07#fig47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 47")]), _vm._v(" Arthur in the Genealogies")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter07#fig48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 48")]), _vm._v(" Arthur’s family tree from Geoffrey of Monmouth")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter07#fig49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 49")]), _vm._v(" Arthur’s family tree from later Welsh sources")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter07#fig50",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 50")]), _vm._v(" A revised family tree")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter07#fig51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 51")]), _vm._v(" Map of Britain c. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 500")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter07#fig52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("Figure 52")]), _vm._v(" Map of Arthur’s battles")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-766d896c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_List.vue
// module id = 72
// module chunks = 0